import {
  SiteFilterType,
  ValidationEventFilter,
} from "../../services/client/types.gen";

export const EVENT_FILTER_LABELS: Record<ValidationEventFilter, string> = {
  MISSING_ASSETS: "Missing assets",
  NOT_RECEIVING_DATA: "Not receiving data",
};

export const EVENT_FILTER_OPTIONS = (
  Object.keys(EVENT_FILTER_LABELS) as ValidationEventFilter[]
).map((value) => ({ label: EVENT_FILTER_LABELS[value], value }));

export const SITE_FILTER_LABELS: Record<SiteFilterType, string> = {
  ALL_SITES: "All sites",
  FILTERED: "Specific sites",
};
